import { useQuery } from "react-query";
import { fetchServer } from "../utils";
import i18n from "@features/i18n";
import _ from "lodash";

export type PackType = {
  id: string;
  style_id?: string;
  prompt: string;
  count: number;
  categories_slug?: string[];
  size: {
    width: number;
    height: number;
  };
};

export const usePacks = () => {
  const packs = useQuery(["packs"], async () => {
    return _.sortBy(
      await fetchServer<PackType[]>("/api/images/packs"),
      (a) => a.id
    );
  });

  return {
    packs,
    refresh: () => packs.refetch(),
  };
};

export const getPackPreview = (id: string, model = "") => {
  const hasMultiShots =
    (i18n.t(["packs." + id + ".single_pic", ""]) as any) !== true;
  return !hasMultiShots
    ? `/packs/${id}.jpg`
    : `/packs/${id}/${model || selectModel(id)}1.jpg`;
};

export function selectModel(key: string): string {
  if (!key || key === "all") {
    return "eva";
  }

  // Liste des modèles
  const models =
    key.includes("sexy") ||
    key.includes("bridal") ||
    key.includes("boudoir") ||
    key.includes("swimsuit") ||
    key.includes("glamour") ||
    key.includes("wife") ||
    key.includes("maternity")
      ? ["eva", "kat"]
      : ["eva", "jay", "kat", "seb"];

  const index = parseInt(key, 36) % models.length;

  return models[index];
}
